module.exports = __webpack_public_path__ + "static/img/3.dc662bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Proteccion-digital-Empresas/3.png
// module id = TfMd
// module chunks = 0